// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"k4-z","dimensionLabel":"l4-z","styleChooserControlWrapper":"m4-z","styleChooserControl":"n4-z","disabled":"o4-z","giftCard":"p4-z","styleChooserText":"q4-z"};